import React from 'react'
import { connect } from 'react-redux'
import { Field, getFormValues } from 'redux-form'
import Tooltip from '@material-ui/core/Tooltip';
import { 
  Icon,
  Button,
  Label
} from 'semantic-ui-react'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { numberFormat } from '../../helper'
import { FileUploadCell } from 'components'
import { getOptionTitle } from '../../helper'
import { purchaseRequisitionDetailPath } from 'routes'

import { Table, TablePage, HH } from './styled'
import r from 'reactotron-react-js'

const itemPerPage = 10

const TableDetail = props => {
  const { 
    isCreate=false, 
    isEdit=false, 
    valueForm, 
    sapDetails, 
    vendorSelectedIndex, 
    change,
    totalPages,
    totalPagesSelect
  } = props

  const [haveMateCode,setHaveMateCode] = React.useState(false)
  const [page,setPage] = React.useState(1)
  const [allPage,setAllPage] = React.useState(false)

  React.useEffect(() => {
    if(valueForm&&valueForm.rfqItems){
      if(valueForm.rfqItems.findIndex(x=>(`${x.materialCode}`.length>0))>=0){
        setHaveMateCode(true)
      }
    }
  },[valueForm&&valueForm.rfqItems])

  React.useEffect(() => {
    if(props.sapDetailReload){
      change('rfqItemVendorAmounts',props.sapDetailReload.rfqItemVendorAmounts)
      change('rfqItems',props.sapDetailReload.rfqItems)
      change('prBudget',props.sapDetailReload.prBudget)
      change('amountAfterDiscount',props.sapDetailReload.amountAfterDiscount)
      change('costSaving',props.sapDetailReload.costSaving)
      change('costSavingPercent',props.sapDetailReload.costSavingPercent)
      props.sapDetailReload.rfqItemVendorTotalAmounts.forEach((x,i)=>{
        change(`rfqItemVendorTotalAmounts[${i}].vendorName`,x.vendorName)
        change(`rfqItemVendorTotalAmounts[${i}].totalBeforeDiscount`,x.totalBeforeDiscount)
        change(`rfqItemVendorTotalAmounts[${i}].paymentCondition`,x.paymentCondition)
        let afDis = (x.totalBeforeDiscount-valueForm.rfqItemVendorTotalAmounts[i].discount)
        change(`rfqItemVendorTotalAmounts[${i}].totalAfterDiscount`,afDis)
        let vatAmount = (afDis*valueForm.vatRate)/100
        change(`rfqItemVendorTotalAmounts[${i}].vatAmount`,vatAmount)
        change(`rfqItemVendorTotalAmounts[${i}].totalAmount`,(vatAmount+afDis))
      })
    }
  },[props.sapDetailReload])

  const onPageChange = (page) =>{
    setPage(page)
    setAllPage(false)
  }

  const onAllPageClick = () =>{
    setAllPage(!allPage)
  }

  return (
    <React.Fragment>
      {(sapDetails&&valueForm&&(valueForm.id>=0))&&<Table>
        <div className='header1'>
          <div className='header1sec1'>
            <HH>Vendor Comparison</HH>
          </div>
          {
            valueForm.rfqItemVendorTotalAmounts.map((item,i)=>{
              return (
                <div key={`rt1${i}`} className={`${vendorSelectedIndex===i?'selected':''} header1sec2`}>
                  <div>Vendor{i+1}</div>
                  <div>{`${item.vendorCode}  ${item.vendorName}`}</div>
                  <div>{`RFQ No. ${item.rfqSapNumber}`}</div>
                </div>
              )
            })
          }
        </div>
        <div className='header2'>
          <div className='header2sec1'>
            <div style={{width:'7rem'}}>PR Ref.</div>
            <div style={{width:'2.5rem'}}>No.</div>
            {haveMateCode&&<div style={{width:'6.2rem'}}>MaterialNo.</div>}
            <div style={{flex:1}}>Item Name</div>
            <div style={{width:'18%'}}>Qty.</div>
            <div style={{width:'3rem'}}>Unit</div>
          </div>
          {
            valueForm.rfqItemVendorTotalAmounts.map((x,i)=>{
              return (
                <div key={`rt2${i}`} className={`header2sec2 ${vendorSelectedIndex===i?'selected':''}`}>
                  <div>Price/Unit<br/><span style={{fontSize:'11px',marginLeft:'0.2rem'}}>({valueForm.currencyCode})</span></div>
                  <div>Total<br/><span style={{fontSize:'11px',marginLeft:'0.2rem'}}>({valueForm.currencyCode})</span></div>
                </div>
              )
            })
          }
        </div>
        {//Row render
          valueForm.rfqItems.map((x,i)=>{
            let pp = Math.ceil((i+1)/itemPerPage)
            if((pp<=page&&pp>(page-1))||allPage){
              return(
                <div key={`rt3${i}`} className='row'>
                  <div className='rowsec1' key={`rt4${i}`}>
                    <div style={{width:'7rem'}} className='colPRRef' onClick={()=>window.open(purchaseRequisitionDetailPath(x.prTrackingNo))}>{x.prTrackingNo}</div>
                    <div style={{width:'2.5rem'}} className='center'>{x.sapLineNo}</div>
                    {haveMateCode&&<div className='center' style={{width:'6.2rem'}}>{Number(x.materialCode)}</div>}
                    <div style={{flex:1}}>
                      <Tooltip title={x.description}>
                        <div>{x.description}</div>
                      </Tooltip>
                    </div>
                    <div className='center' style={{width:'18%'}}>{numberFormat(x.quantity,false,3)}</div>
                    <div className='center' style={{width:'3rem'}}>{getOptionTitle(props.unitOptions,x.unitCode,false)}</div>
                  </div>
                  {
                    valueForm.rfqItemVendorAmounts.filter(y=>y.sapLineNo===x.sapLineNo).map((item,i)=>{
                      return (
                        <div key={`rt5${i}`} className={`rowsec2 ${vendorSelectedIndex===i?'selected':''}`}>
                          <div className='number'>{numberFormat(item.vendorUnitPrice)}</div>
                          <div className='number'>{numberFormat(item.vendorTotal)}</div>
                        </div>
                      )
                    })
                  }
                </div>
              )
            }else 
              return null
          })
        }
        {/* Item Pagination */}
        {totalPages>1&&
        <div key='tts1' className='row'>
          <div className='rowsec1' key='tts2'>
            <TablePage>
              Page
              <select
                onChange={e => onPageChange(Number(e.target.value))}
                value={page}
              >
                {totalPagesSelect.map((option, i) => (
                  <option key={i} value={option}>{option}</option>
                ))}
              </select>
              /{totalPages}{' '}
              <Label as='a' onClick={()=>onAllPageClick()}>All</Label>
            </TablePage>
          </div>
          {valueForm.rfqItemVendorTotalAmounts.map((x,i)=>(
            <div key='tts3' className={`rowsec2 ${vendorSelectedIndex===i?'selected':''}`}/>
          ))}
        </div>}

        <div className='rowField'>
          <div className='rowFieldTitle'>
            <div>Total Amount</div>
          </div>
          {//Row field
            valueForm.rfqItemVendorTotalAmounts.map((item,i)=>{
              return (
                <div key={`rt6${i}`} className={`${vendorSelectedIndex===i?'selected':''} rowFieldInput`}>
                  <div className='number'>{numberFormat(item.totalBeforeDiscount)}</div>
                </div>
              )
            })
          }
        </div>
        <div className='rowField'>
          <div className='rowFieldTitle'>
            <div>Discount</div>
          </div>
          {
            valueForm.rfqItemVendorTotalAmounts.map((item,i)=>{
              return (
                <div key={`rt7${i}`} className={`${vendorSelectedIndex===i?'selected':''} rowFieldInput discount`}>
                  <Field 
                    editable={(isCreate||isEdit)}
                    name={`rfqItemVendorTotalAmounts[${i}].discount`}
                    type={type.number} 
                    allowNegative={false} 
                    fixedDecimalScale
                    onChange={(v=>{
                      let item = valueForm.rfqItemVendorTotalAmounts[i]
                      let totalAfterDiscount = item.totalBeforeDiscount-v
                      change(`rfqItemVendorTotalAmounts[${i}].totalAfterDiscount`, totalAfterDiscount)
                      let vatAmount = (totalAfterDiscount*valueForm.vatRate)/100
                      change(`rfqItemVendorTotalAmounts[${i}].vatAmount`, vatAmount)
                      change(`rfqItemVendorTotalAmounts[${i}].totalAmount`, vatAmount + totalAfterDiscount)
                      if(vendorSelectedIndex===i){
                        let costSaving = valueForm.prBudget - totalAfterDiscount
                        change('costSaving', costSaving)
                        change('costSavingPercent', (costSaving*100)/valueForm.prBudget)
                        change('amountAfterDiscount', totalAfterDiscount)
                        change('netAmount', vatAmount + totalAfterDiscount)
                        change('vatAmount', vatAmount)
                      }
                    })}
                    component={FieldInput} />
                </div>
              )
            })
          }
        </div>
        <div className='rowField'>
          <div className='rowFieldTitle'>
            <div>After Discount Amount</div>
          </div>
          {
            valueForm.rfqItemVendorTotalAmounts.map((item,i)=>{
              return (
                <div key={`rt8${i}`} className={`${vendorSelectedIndex===i?'selected':''} rowFieldInput`}>
                  <div className='number'>{numberFormat(item.totalAfterDiscount)}</div>
                </div>
              )
            })
          }
        </div>
        <div className='rowField'>
          <div className='rowFieldTitle'>
            <div className='vatRate'>
              <span>Vat</span>
              <Field 
                editable={(isCreate||isEdit)}
                name='vatRate'
                containerStyle={{ marginRight: '0px' }} 
                suffix='%' 
                marginLess
                type={type.number} 
                allowNegative={false} 
                onChange={(v=>{
                  valueForm.rfqItemVendorTotalAmounts.forEach((item,i)=>{
                    let vatAmount = (item.totalAfterDiscount*v)/100
                    change(`rfqItemVendorTotalAmounts[${i}].vatAmount`, vatAmount)
                    change(`rfqItemVendorTotalAmounts[${i}].totalAmount`, vatAmount+item.totalAfterDiscount)
                    if(vendorSelectedIndex===i){
                      change('netAmount', vatAmount + item.totalAfterDiscount)
                      change('vatAmount', vatAmount)
                    }
                  })
                })}
                component={FieldInput} />
            </div>
          </div>
          {
            valueForm.rfqItemVendorTotalAmounts.map((item,i)=>{
              return (
                <div key={`rt9${i}`} className={`${vendorSelectedIndex===i?'selected':''} rowFieldInput`}>
                  <div className='number'>{numberFormat(item.vatAmount)}</div>
                </div>
              )
            })
          }
        </div>
        <div className='rowField'>
          <div className='rowFieldTitle'>
            <div>Net Amount (Inc.VAT)</div>
          </div>
          {
            valueForm.rfqItemVendorTotalAmounts.map((item,i)=>{
              return (
                <div key={`rt10${i}`} className={`${vendorSelectedIndex===i?'selected':''} rowFieldInput`}>
                  <div className='number'>{numberFormat(item.totalAmount)}</div>
                </div>
              )
            })
          }
        </div>
        <div className='rowField'>
          <div className='rowFieldTitle'>
            <div>Project information</div>
          </div>
          {
            valueForm.rfqItemVendorTotalAmounts.map((item,i)=>{
              return (
                <div key={`rt11${i}`} className={`${vendorSelectedIndex===i?'selected':''} rowFieldInput`}>
                  <div className='rowFieldArea'>
                    <Field 
                      editable={(isCreate||isEdit)}
                      name={`rfqItemVendorTotalAmounts[${i}].projectInformation`}
                      type={type.textArea}
                      component={FieldInput} />
                  </div>
                </div>
              )
            })
          }
        </div>
        <div className='rowField'>
          <div className='rowFieldTitle'>
            <div>Time of Completion</div>
          </div>
          {
            valueForm.rfqItemVendorTotalAmounts.map((item,i)=>{
              return (
                <div key={`rt12${i}`} className={`${vendorSelectedIndex===i?'selected':''} rowFieldInput`}>
                  <div className='rowFieldArea'>
                    <Field 
                      editable={(isCreate||isEdit)}
                      name={`rfqItemVendorTotalAmounts[${i}].projectLength`} 
                      type={type.textArea}
                      component={FieldInput} />
                  </div>
                </div>
              )
            })
          }
        </div>
        <div className='rowField'>
          <div className='rowFieldTitle'>
            <div>Credit term</div>
          </div>
          {
            valueForm.rfqItemVendorTotalAmounts.map((item,i)=>{
              return (
                <div key={`rt13${i}`} className={`${vendorSelectedIndex===i?'selected':''} rowFieldInput`}>
                  <div className='rowFieldArea'>
                    <Field 
                      editable={(isCreate||isEdit)}
                      name={`rfqItemVendorTotalAmounts[${i}].creditTerm`} 
                      type={type.textArea}
                      component={FieldInput} />
                  </div>
                </div>
              )
            })
          }
        </div>
        <div className='rowField'>
          <div className='rowFieldTitle'>
            <div>Warranty</div>
          </div>
          {
            valueForm.rfqItemVendorTotalAmounts.map((item,i)=>{
              return (
                <div key={`rt14${i}`} className={`rowFieldInput ${vendorSelectedIndex===i?'selected':''}`}>
                  <div className='rowFieldArea'>
                    <Field 
                      editable={(isCreate||isEdit)}
                      name={`rfqItemVendorTotalAmounts[${i}].warranty`} 
                      type={type.textArea}
                      component={FieldInput} />
                  </div>
                </div>
              )
            })
          }
        </div>
        <div className='rowField'>
          <div className='rowFieldTitle'>
            <div>Quotation{' '}<span style={{color:'red'}}>*</span></div>
          </div>
          {
            valueForm.rfqItemVendorTotalAmounts.map((item,i)=>{
              return (
                <div key={`rt15${i}`} className={`${vendorSelectedIndex===i?'selected':''} rowFieldInput`}>
                  <div className='rowFieldFile'>
                    {(isCreate||isEdit)?
                      <React.Fragment>
                        <Field
                          name={`vendorQuatationAttachtments.v${item.vendorCode}|${item.rfqSapNumber}`}
                          type={type.file}
                          component={FieldInput}
                        />
                        {valueForm.rfqItemVendorQuatationAttachtments[i].fileItems.filter(x=>x.deleted==false).map((file,fileIndex)=>{
                          return(
                            <span className='oldFile'>
                            <FileUploadCell
                              key={`${file.originalFilename}${fileIndex}`}
                              fileName={file.originalFilename}
                              fileSize={file.size}
                              urlPath={file.urlPath}
                              onClickDelete={() => {
                                change(`rfqItemVendorQuatationAttachtments[${i}].fileItems[${fileIndex}].deleted`,true)
                              }}
                            /></span>
                          )
                        })}
                      </React.Fragment>
                    :
                    <div>
                      {
                        valueForm.rfqItemVendorQuatationAttachtments.filter(x=>x.vendorCode===item.vendorCode && (x.rfqSapNumber==item.rfqSapNumber||x.rfqSapNumber==null)).map(x=>(
                          x.fileItems.map(y=>(
                            <Tooltip title={y.originalFilename}>
                              {/* <Button type='button' content={<div className='fileNameContent'>{y.originalFilename}</div>} icon='download' labelPosition='left' onClick={()=>(window.open(y.urlPath,"_blank"))}/> */}
                              <Button type='button' content={<div className='fileNameContent'>{y.originalFilename}</div>} icon='download' labelPosition='left' onClick={()=>(window.location.href = y.urlPath)}/>
                            </Tooltip>
                          ))
                        ))
                      }
                    </div>
                    }
                  </div>
                </div>
              )
            })
          }
        </div>
        <div className='rowField'>
          <div className='rowFieldTitle'>
            <div>Payment Condition</div>
          </div>
          {
            valueForm.rfqItemVendorTotalAmounts.map((item,i)=>{
              return (
                <div key={`rt16${i}`} className={`${vendorSelectedIndex===i?'selected':''} rowFieldInput`}>
                  <div className='rowFieldArea'>
                    <Field 
                      editable={false}
                      name={`rfqItemVendorTotalAmounts[${i}].paymentCondition`} 
                      type={type.textArea}
                      component={FieldInput} />
                  </div>
                </div>
              )
            })
          }
        </div>
        <div className='rowField'>
          <div className='last rowFieldTitle'>
            <div>Please Choose a Vendor:</div>
          </div>
          {
            valueForm.rfqItemVendorTotalAmounts.map((item,i)=>{
              return (
                <div key={`rt17${i}`} className={`${vendorSelectedIndex===i?'selected':''} rowFieldInput`}>
                  <div className='btn'>
                    {vendorSelectedIndex===i?
                      <div className='textSelected'>
                        <Icon.Group size='large'>
                          <Icon name='clipboard list' />
                          <Icon corner name='check' />
                        </Icon.Group>
                        Selected
                      </div>
                      :null
                    }
                  </div>
                </div>
              )
            })
          }
        </div>
      </Table>}
    </React.Fragment>
  )
}

const mapStateToProps = (state, props) => {
  var valueForm = getFormValues('formRFQ')(state)
  var totalPages = 0;
  var totalPagesSelect = [];
  if(valueForm&&valueForm.rfqItems&&valueForm.rfqItems.length){
    totalPages = Math.ceil(valueForm.rfqItems.length/itemPerPage)
    for(let i=1;i<=totalPages;i++){
      totalPagesSelect.push(i)
    }
  }
  var sapDetails = state.rfq.sapDetails.data
  var vendorSelectedIndex =  sapDetails ? 
    sapDetails.rfqItemVendorTotalAmounts?sapDetails.rfqItemVendorTotalAmounts.findIndex(x=>x.isVendorSelected)
    :-1:-1
  return {
    totalPages,
    totalPagesSelect,
    valueForm,
    sapDetails,
    vendorSelectedIndex,
    unitOptions:state.options.units.data,
    sapDetailReload:state.rfq.sapDetailReload.data
  }
}
const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(TableDetail)
